// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class UserSettings extends Model {
    static table = 'user_settings';

    @field('user_id') userId;
    @field('topic') topic;
    @field('description') description;
    @field('enabled') enabled;
    @readonly @date('created_at') createdAt;
    @readonly @date('updated_at') updatedAt;
}

export type UserSettingsSimple = {
    id: string;
    userId: string;
    topic: string;
    description: string;
    enabled: boolean;
    createdAt: number;
    updatedAt: number;
};
